module.exports = __webpack_public_path__ + "static/media/2017Earthfest2.f7a94e81.jpg";